import React, { useState,useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faBriefcase, faFileAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import '../../pages/comdash.css';
import './card.css';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import CompanyNavbar from "./CompanyNavbar";
function AddEmployee() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const [company_name,setCompanyname] = useState("");
  const [image,setImage] = useState("");
  function  FetchCompanyDetails() {
    axios.get(`${url.path}/login_details/${ID}/`)
    .then((res) =>{
      if (res.data.status){
        setCompanyname(res.data.name);
        const img = res.data.image;
        var imag = null
        if (img) {
          imag = `${url.path}/${img}`;
        }
        setImage(imag);
      }
    })
    .catch((err) => {
      Toast.fire({
        icon:'error',
        title:err
      })
    });
  }
  useEffect(()=>{
    FetchCompanyDetails();
  },[])
  const [fileName, setFileName] = useState("");
  const [file,setFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setFile(file);
    }
  };
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  function add_employee(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('id',ID);
    formdata.append('file',file);
    axios.post(`${url.path}/add_employees/`,formdata)
    .then((res) =>{
      if (res.data.status){
        Toast.fire({
          icon: "success",
          title: "Employees Added successfully",
        });
        navigate("/add_employees");
      }
    })
    .catch((err) => {
      if(!err.response.data.status){
        Swal.fire({
          icon: "error",
          title: `${err.response.data.message}`,
        });
      }
    });
  }
  const handleDownload = () => {
    const additionalHeaders = ["FullName", "EmployeeID", "Email", "Contact", "Designation", "Role", "Department"];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([additionalHeaders]); 
    XLSX.utils.book_append_sheet(wb, ws, "Add Employees");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, "Add Employees.xlsx");
  };
    return(
    <>
    <CompanyNavbar />
    <div className="content">
                <div className="card">
                  <h2 className="card-title">Upload Excel File</h2>
                  <p className="card-description">
                    Please upload your Excel file in .xls or .xlsx format.
                  </p>
                  <form onSubmit={add_employee}>
                  <div className="input-container">
                    <input
                      type="file"
                      accept=".xls,.xlsx"
                      id="file-input"
                      className="file-input"
                      onChange={handleFileChange}
                    />
                    <label htmlFor="file-input" className="file-label mt-2">
                    {fileName}
                    </label>
                    <center>
                    <button type="submit"  style={{border:'1px solid red',width:'100px'}}>Add</button>
                    </center>
                    
                  </div>
                  </form>
                <button className="mt-2" onClick={handleDownload}>Download Format</button>
            </div>
          </div>
    </>
    );
}
export default AddEmployee;